import photography from "../../../assets/photography.JPG";
import concerts from "../../../assets/concerts.jpg";
import foodie from "../../../assets/foodie.jpg";
import reading from "../../../assets/reading.jpg";
import shows from "../../../assets/shows.jpg";

export const interestData = [
  {
    name: "Photography",
    image: photography,
    description:
      "Given the 7,000 photos in my camera roll, I love taking photos and capturing memories. The photo above is from a trip to Cancun (the revival of my DSLR). Click the link below to see some photos from when my friends and I went to Providence!",
    buttonText: "Album",
    url: "https://photos.app.goo.gl/AizLRsxWudHXeJz89",
  },
  {
    name: "Concerts",
    image: concerts,
    description:
      "I love attending concerts and went to over 10 in the course of just Fall 2022 (including the one above - Joji and Dhruv in October). I'll listen to anything that's not Country or EDM. Click the link below to check out my Spotify!",
    buttonText: "Spotify",
    url: "https://open.spotify.com/user/sreya.k417?si=b631d59265fb434c",
  },
  {
    name: "Foodie",
    image: foodie,
    description:
      "Though I haven't made a food account yet, I love documenting the best restaurants I go to in different cities. Some of my favorites were in Portland, Oregon and San Diego, CA (like the one above!). Click the link below for a recent rec in NYC",
    buttonText: "Rec",
    url: "http://mewnyc.com/",
  },
  {
    name: "Reading",
    image: reading,
    description:
      "Though I fittingly work at Scholastic, reading has something I've always loved since I was a kid (I was a sucker for all the YA dystopian books back in the day). Check the rec below for one of my favorite books ever!",
    buttonText: "Rec",
    url: "https://www.goodreads.com/book/show/22628.The_Perks_of_Being_a_Wallflower",
  },
  {
    name: "Shows",
    image: shows,
    description:
      "I recently got an HBO Max subscription and cannot stop raving about every other show on there. Though I don't have much time to binge shows nowadays, I'll try to make time for it every now and then. One of my recent favorites is below",
    buttonText: "Rec",
    url: "https://www.hbo.com/the-white-lotus",
  },
];
